// src/components/common/RoleBadge.js
import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { ACCOUNT_TYPES } from "../../services/profileService";

export default function RoleBadge({ role = "creator", isAdmin = false, accountType = null }) {
  const normalizedType = String(accountType || "").toLowerCase();
  const isBusiness = normalizedType === ACCOUNT_TYPES.BUSINESS;
  const isIndividual = normalizedType === ACCOUNT_TYPES.INDIVIDUAL;
  const label = isAdmin ? "Admin" : isBusiness ? "Business" : isIndividual ? "Individual" : "Creator";
  const color = isAdmin ? "warning" : isBusiness ? "primary" : "default";

  return (
    <Tooltip title={`Signed in as ${label}`}>
      <Chip
        size="small"
        color={color}
        variant="filled"
        label={label}
        sx={{
          height: 28,
          borderRadius: "8px",
          "& .MuiChip-label": {
            fontSize: "0.69rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
          },
        }}
      />
    </Tooltip>
  );
}
